module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Cooking/Sieve-f190a518044af7abaa8f91f1190e20237bdbcf54bae4c08ad73c04b442506bca.svg";